import type { IApplicationApiPrivateJSON } from "shared"
import { ZApplicationApiPrivate } from "shared"
import { APPLICANT_ANSWER_MAX_LENGTH } from "shared/models/applications.model"
import { validatePhone } from "shared/validators/phone-validator"
import { z } from "zod"

import { sessionStorageGet } from "@/utils/local-storage"

export type IApplicationSchemaInitValues = Omit<IApplicationApiPrivateJSON, "caller">

export function getInitialSchemaValues(): IApplicationSchemaInitValues {
  const inSessionValue = JSON.parse(sessionStorageGet("application-form-values"))
  return {
    applicant_first_name: inSessionValue?.applicant_first_name ?? "",
    applicant_last_name: inSessionValue?.applicant_last_name ?? "",
    applicant_email: inSessionValue?.applicant_email ?? "",
    applicant_phone: inSessionValue?.applicant_phone ?? "",
    applicant_attachment_name: inSessionValue?.applicant_attachment_name ?? "",
    applicant_attachment_content: inSessionValue?.applicant_attachment_content ?? "",
    applicant_message: inSessionValue?.message ?? "",
    applicant_contract_duration: inSessionValue?.applicant_contract_duration ?? "",
    applicant_contract_start: inSessionValue?.applicant_contract_start ?? [],
    applicant_formation_description: inSessionValue?.applicant_formation_description ?? "",
    applicant_inscription_formation: inSessionValue?.applicant_inscription_formation ?? undefined,
    applicant_rythm_description: inSessionValue?.applicant_rythm_description ?? "",
  }
}

export const ApplicationFormikSchema = ZApplicationApiPrivate.pick({
  applicant_attachment_name: true,
  applicant_formation_description: true,
  applicant_rythm_description: true,
}).extend({
  applicant_first_name: z.string({ error: "Le prénom est obligatoire" }).trim().min(1, "Le prénom est obligatoire"),
  applicant_last_name: z.string({ error: "Le nom est obligatoire" }).trim().min(1, "Le nom est obligatoire"),
  applicant_email: z.string({ error: "L'adresse email est obligatoire" }).email("Format attendu : nom@domaine.fr").trim(),
  applicant_phone: z
    .string({ error: "Le téléphone est obligatoire" })
    .trim()
    .refine(validatePhone, { message: "Téléphone non valide : veuillez utiliser le format international (+33XXX...) ou national (06XXX...)" }),
})

export const formatCount = (count: number) => count.toLocaleString("fr-FR")

// .trim().min(1) en plus du message de type : formik convertit la chaîne vide en undefined avant validation,
// mais une réponse composée uniquement d'espaces lui parvient telle quelle.
// .max() avant .trim() : la réponse est envoyée sans trim, le serveur borne sa longueur brute.
export const QuestionAnswerSchema = z
  .string({ error: "Une réponse est obligatoire" })
  .max(APPLICANT_ANSWER_MAX_LENGTH, `Votre réponse dépasse ${formatCount(APPLICANT_ANSWER_MAX_LENGTH)} caractères, veuillez la raccourcir.`)
  .trim()
  .min(1, "Une réponse est obligatoire")
